<template>
    <div>
        <v-text-field
                v-model="fieldValue"
                :counter="50"
                label="Company Name"
                required
                :error-messages="fieldValueErrors"
                @input="$v.fieldValue.$touch()"
                @blur="$v.fieldValue.$touch()"
        ></v-text-field>
    </div>
</template>

<script>
  import {FieldMixin} from '@/forms/mixins'
  import {required, minLength, maxLength} from 'vuelidate/lib/validators'

  // NOTE: the FieldsMixin provides the validation and update logic to notify the parent form
  export default {
    name: 'CompanyNameFields',
    mixins: [FieldMixin],
    validations: {
      fieldValue: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50)
      }
    },
    computed: {
      fieldValueErrors () {
        const errors = []
        if (!this.$v.fieldValue.$dirty) return errors
        !this.$v.fieldValue.required && errors.push('Company name is required.')
        !this.$v.fieldValue.minLength && errors.push('Company name must be at least 2 characters long')
        !this.$v.fieldValue.maxLength && errors.push('Company name must be at most 50 characters long')
        return errors
      }
    }
  }
</script>

<style scoped>

</style>
